import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getInitiativesJiraIssues } from '@api';
import { InitiativeJiraIssuesName } from '../name';

export const getInitiativesJiraIssueSlice = createGetAsyncSlice({
	name: InitiativeJiraIssuesName,
	receive: true,
	request: true,
	requestHandler: getInitiativesJiraIssues,
	retainDataOnRequest: true
});
